import { useContext } from "react";
import {
  ProfileContext,
  type ProfileContextType,
} from "../contexts/ProfileContext";

export const useCurrentProfile = (): ProfileContextType => {
  const context = useContext(ProfileContext);
  if (context === undefined) {
    throw new Error("useCurrentProfile must be used within a ProfileProvider");
  }
  return context;
};
